import React from "react";
import "./reservation.scss";
import {ApiEngine} from "api-engine";
import { downloadICS } from "../../utils/calendar";
import { hapticSelect } from "../../utils/haptic";

interface ReservationProps {
  reservation: any;
  api: ApiEngine;
}

interface ReservationState {}

function pad(_num: number, size: number) {
  let num = _num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export default class ReservationView extends React.Component<ReservationProps, ReservationState> {
  constructor(props: ReservationProps) {
    super(props);
    this.state = {};
    this.addToCalendar = this.addToCalendar.bind(this);
    this.getCalendarEvent = this.getCalendarEvent.bind(this);
  }

  getCalendarEvent() {
    const me = this;
    const reservation = me.props.reservation;

    const today = new Date();
    const startDate = new Date(today);
    const endDate = new Date(today);

    const startHours = Math.floor(reservation.seconds_start / 3600);
    const startMinutes = Math.floor((reservation.seconds_start % 3600) / 60);

    startDate.setHours(startHours, startMinutes, 0, 0);
    endDate.setTime(startDate.getTime() + reservation.duration * 1000);

    return {
      title: `Переговорка: ${reservation.meeting_room?.title || 'Бронирование'}`,
      description: 'Бронирование переговорки\\nhttps://schedule.skobeltsyn.com',
      location: reservation.meeting_room?.title || '',
      startDate,
      endDate,
    };
  }

  addToCalendar() {
    hapticSelect();
    const event = this.getCalendarEvent();
    downloadICS(event);
  }

  render() {
    let me = this;
    let _dateStart = new Date(me.props.reservation.seconds_start * 1000 );
    let _dateEnd = new Date(me.props.reservation.seconds_start * 1000 + 1000 * me.props.reservation.duration );
    let dateStart = new Date(_dateStart.getTime() + 0 * 1000 * 60 * _dateStart.getTimezoneOffset());
    let dateEnd = new Date(_dateEnd.getTime() + 0 * 1000 * 60 * _dateEnd.getTimezoneOffset());

    return <div className={"reservation"}>
      <img
        src={`${me.props.api.serverUrl}${me.props.reservation.meeting_room.image_url}`}
        alt={`Переговорная комната ${me.props.reservation.meeting_room.title}`}
      />
      <div className={"content"}>
        <p style={{display: "none"}}>{JSON.stringify(me.props.reservation)}</p>
        <div className={"column"}>
          <p>{me.props.reservation.meeting_room.title}</p>
          <p className={"time"}>{`${pad(dateStart.getUTCHours(), 2)}:${pad(dateStart.getUTCMinutes(), 2)}`}-{`${pad(dateEnd.getUTCHours(), 2)}:${pad(dateEnd.getUTCMinutes(), 2)}`}</p>
        </div>
        <button
          className={"calendar-btn"}
          onClick={(e) => {
            e.stopPropagation();
            me.addToCalendar();
          }}
          title="Добавить в календарь"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="calendar-icon">
            <path d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm304-64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z" className="fa-secondary"/>
            <path d="M448 112v80H0v-80a48 48 0 0 1 48-48h48v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h128v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h48a48 48 0 0 1 48 48z" className="fa-primary"/>
          </svg>
        </button>
        <p className={"id"}>{me.props.reservation.id}</p>
      </div>
    </div>
  }
}